import React from "react";
import Seo from "../components/Seo";
import { ACTIVE_GAME_SOURCE_NAME } from "../data/games";

const ContentProvider = () => {
  return (
    <main className="page legal-page">
      <Seo
        title="Content Provider"
        description="Information about OctoGames content providers and game licensing sources."
        path="/legal/content-provider"
        keywords="content provider, octogames games provider, octogames.io, gamemonetize"
      />
      <div className="container legal-container">
        <article className="legal-card">
          <h1 className="legal-title">Content Provider</h1>
          <p className="legal-intro">
            Last updated: February 14, 2026
          </p>
          <p className="legal-copy">
            This page explains how game content is provided on OctoGames and clarifies ownership,
            licensing, and responsibility boundaries for embedded content.
          </p>

          <h2 className="legal-section-title">1. Platform Model</h2>
          <p className="legal-copy">
            OctoGames is operated by a private individual located in Ukraine and functions as a
            game discovery and access platform. Most games are embedded from third-party providers
            rather than hosted as original first-party game productions.
          </p>

          <h2 className="legal-section-title">2. Primary Game Provider</h2>
          <p className="legal-copy">
            The active source of embedded HTML5 game content is {ACTIVE_GAME_SOURCE_NAME}. We keep
            support for multiple feed providers and can switch between them when needed.
          </p>
          <p className="legal-copy">
            Provider references:{" "}
            <a href="https://gamemonetize.com/" target="_blank" rel="noreferrer">
              gamemonetize.com
            </a>{" "}
            and{" "}
            <a href="https://octogames.io/" target="_blank" rel="noreferrer">
              octogames.io
            </a>
            .
          </p>

          <h2 className="legal-section-title">3. Ownership and Intellectual Property</h2>
          <p className="legal-copy">
            All rights in embedded games, game assets, trademarks, and associated materials remain
            with their respective owners, licensors, and publishers. Listing or embedding a game on
            OctoGames does not transfer ownership rights to OctoGames or users.
          </p>

          <h2 className="legal-section-title">4. Embedding and Delivery</h2>
          <p className="legal-copy">
            Embedded games may be delivered from third-party infrastructure and may include
            third-party scripts, analytics, and advertising technologies. Game availability,
            language options, monetization format, and technical behavior can vary by provider,
            device, and region.
          </p>

          <h2 className="legal-section-title">5. Content Availability and Changes</h2>
          <p className="legal-copy">
            We may add, remove, replace, or reorder games and providers at any time without prior
            notice. Certain games may become unavailable due to provider decisions, licensing scope,
            policy updates, geoblocking, maintenance, or legal requirements.
          </p>

          <h2 className="legal-section-title">6. Third-Party Terms and Policies</h2>
          <p className="legal-copy">
            Use of specific embedded games may be subject to third-party terms, end-user rules,
            privacy policies, and advertising frameworks. Users are responsible for reviewing and
            complying with such third-party terms where applicable.
          </p>

          <h2 className="legal-section-title">7. Prohibited Use of Content</h2>
          <p className="legal-copy">
            Unless expressly allowed by the applicable rights holder, you must not copy, download,
            redistribute, reverse engineer, re-license, or commercially exploit embedded game
            content available through OctoGames.
          </p>

          <h2 className="legal-section-title">8. Rights Holder Notices</h2>
          <p className="legal-copy">
            If you are a copyright owner, authorized representative, or rights holder and believe
            content shown on OctoGames infringes your rights, send a detailed notice including:
          </p>
          <ul className="legal-list">
            <li>Identification of the content and where it appears on OctoGames.</li>
            <li>Proof of ownership or authority to act on behalf of the rights holder.</li>
            <li>Your contact details and a clear description of the claim.</li>
            <li>Any supporting evidence needed to evaluate the request.</li>
          </ul>
          <p className="legal-copy">
            We will review notices in good faith and may remove or restrict access where appropriate.
          </p>

          <h2 className="legal-section-title">9. Contact</h2>
          <p className="legal-copy">
            For provider-related questions, rights claims, or legal notices regarding embedded game
            content, contact:{" "}
            <a href="mailto:support@octogames.io">support@octogames.io</a>.
          </p>
        </article>
      </div>
    </main>
  );
};

export default ContentProvider;
